import { Instant } from '@js-joda/core'

export enum JobSpecDomain {
  INGESTION = 'INGESTION',
  PRODUCTION = 'PRODUCTION',
}

export interface JobSpec {
  domain: JobSpecDomain
  ingestion?: IngestionJobSpec
  production?: null // placeholder
}

export interface IngestionJobSpec {
  type: IngestionJobSpecType
  workItemAssignment?: WorkItemAssignment
  workOrderAssignment?: WorkOrderAssignment
  invalidPreparationRetry?: InvalidPreparationRetry
  preparationItem?: PreparationItem
}

export interface WorkItemAssignment {
  workItemId: string
  workOrderId: string
}

export interface WorkOrderAssignment {
  workOrderIds: string[]
}

export interface InvalidPreparationRetry {
  timestamp: Instant
  facility: string
}

export interface PreparationItem {
  workItemId: string
}

export enum IngestionJobSpecType {
  ASSIGN_MISSING_WORK_ITEM_PROD_ROUTE = 'ASSIGN_MISSING_WORK_ITEM_PROD_ROUTE',
  ASSIGN_MISSING_WORK_ORDER_ITEMS_PROD_ROUTE = 'ASSIGN_MISSING_WORK_ORDER_ITEMS_PROD_ROUTE',
  INVALID_PREPARATION_RETRY = 'INVALID_PREPARATION_RETRY',
  PREPARATION_ITEM = 'PREPARATION_ITEM',
}
